module.exports = "/images/menora.png?f4bddd013b8af58fece28c945ed2e022";